module.exports = __webpack_public_path__ + "53b614aa4574c9ecb71e411214bdf7af.png";